<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :vertical="false"
      :timeout="timeout"
      top="top"
      :color="tipo"
      elevation="5"
      multi-line
      right
    >
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
    <RelatorioPowerBi :titulo="titulo" :reportId="reportId" />
  </v-container>
</template>
<script>
import utilsStorage from "@/utils/storage";
import mixinMensagen from "@/mixin/mixin-mensagem";
import RelatorioPowerBi from "./RelatorioPowerBi.vue";
import embedTokenApi from "../../api/reports/embed-token-api";
import EmbedToken from "@/model/token/EmbedToken";

export default {
  name: "PowerBIGenerico",
  mixins: [mixinMensagen],
  components: { RelatorioPowerBi },
  data() {
    return {
      titulo: "Relatorio",
      workspaceId: undefined,
      reportId: undefined,
    };
  },

  async mounted() {
    if (this.$route.params) {
      this.titulo = this.$route.params.reportName;

      /*
       * Verificar se já existe token para esse reportId na storage
       * Só gerar um novo token se o antigo estiver expirado.
       */
      let token = utilsStorage.obterEmbedTokenNaStorage(this.$route.params.reportId);
      if (!token || token.expiry < new Date().toISOString()) {
        await this.obterEmbedToken(
          this.$route.params.workspaceId,
          this.$route.params.reportId
        );
      } else {
        this.reportId = this.$route.params.reportId;
        this.workspaceId = this.$route.params.workspaceId;
      }
    }
  },

  methods: {
    async obterEmbedToken(workspaceId, reportId) {
      embedTokenApi
        .obter(workspaceId, reportId)
        .then((response) => {
          let embedUrl = response.data.embedUrl[0].embedUrl;

          let token = new EmbedToken({
            accessToken: response.data.accessToken,
            expiry: response.data.expiry,
            embedUrl,
            reportId,
          });

          this.reportId = token.reportId;

          utilsStorage.salvarEmbedTokenNaStorage(token);
        })
        .catch((error) => {
          this.dispararMensagem(
            error.response &&
              error.response.data &&
              error.response.data.message,
            "error"
          );
        });
    },
  },
};
</script>
